// pipe: frontend wave — QMS sidebar entry (links to the QMS dashboard; the in-family nav
// reaches training/calibration/documents/ncr/audits/reviews). Cloned from records-button.tsx
// (verbatim shape) — only the route, the active-path prefix, the icon, the label key, and the
// testid differ. NOT admin-gated (the server enforces; screens render the localized load-error).
import { useI18n } from '@affine/i18n';
import { DoneIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const QmsButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any /qms/* route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/qms');

  return (
    <MenuLinkItem icon={<DoneIcon />} active={active} to={'/qms/dashboard'}>
      <span data-testid="pipe-qms-nav">{t['com.affine.pipe.qms.nav']()}</span>
    </MenuLinkItem>
  );
};
